import React, { useState } from 'react';
import { createLyceeThenClasse } from '../../../../../REST/createLyceeClasse/createLyceeClasse';
import { RecapLycee } from './RecapLycee';
import { RecapClasse } from './Recapclasse';
import { ClasseDefTypes } from '../../../../../types/classe/classe.def';
import { LyceeDef } from '../../../../../types/lycee/lycee.def';
import pages from '../../../../../routes/pages';
import { ButtonWithText } from '../../../../atoms/Buttons/ButtonWithText';
import toast from 'react-hot-toast';

interface ValidationStepTypes {
  classe: ClasseDefTypes;
  lycee: LyceeDef;
  setStep: (step) => void;
  step: number;
}

export const ValidationStep = ({
  classe,
  lycee,
  setStep,
  step
}: ValidationStepTypes) => {
  const [loading, setLoading] = useState(false);

  const submit = (): Promise<void> => {
    setLoading(true);
    setStep(step + 1);
    return createLyceeThenClasse({ lycee, classe })
      .then(resp => {
        toast.success(resp.message, { duration: 6000 });
        setTimeout(() => window.location.assign(pages.HOME_PAGE.path), 6000);
      })
      .catch(err => {
        toast.error(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <h2 style={{ margin: 'auto' }}>
        Récap de vos informations{' '}
        <span role="img" aria-label="emoji doigt vers le bas">
          👇
        </span>
      </h2>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          width: '70%',
          margin: 'auto',
          padding: '20px'
        }}
      >
        <RecapLycee lycee={lycee} />
        <RecapClasse classe={classe} />
        <p>Toutes ces informations sont correctes ?</p>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <ButtonWithText
          content={'Non, je  dois corriger'}
          onClick={() => setStep(step - 1)}
          icon={'LeftArrow'}
          iconColor={'white'}
          variant={'primaryBlue'}
          iconPosition={'start'}
        />
        <ButtonWithText
          content={'Oui, allons-y'}
          onClick={submit}
          icon={'Tick'}
          iconColor={'white'}
          variant={'primaryBlue'}
          loading={loading}
        />
      </div>
    </>
  );
};
